export const ENV = {
  LOCAL: 'local',
  DEV: 'dev',
  PROD: 'prod',
} as const

export type IEnvValue = (typeof ENV)[keyof typeof ENV]

export const ENV_LABELS: Record<IEnvValue, string> = {
  [ENV.LOCAL]: 'Local',
  [ENV.DEV]: 'Dev',
  [ENV.PROD]: 'Production',
}
